module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-259.f6b947c0.svg";